import { Component, Input } from '@angular/core';
import { EventCopy } from '../shared/event-copy.model';
import { UserService } from 'src/app/users/shared/user.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { DialogService, TranslationService } from 'src/app/shared';
import { EventsV4Service } from '../shared/events-v4.service';
import { EventRead } from '../shared/event-read.model';
import { EventV4CustomRegFieldService } from '../shared/custom-reg-fields/event-v4-custom-reg-field.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'wl-events-v4-copy',
  templateUrl: './events-v4-copy.component.html',
  styleUrl: './events-v4-copy.component.less',
    standalone: false
})
export class EventsV4CopyComponent {
  @Input('eventId') eventid: number;
  @Input('event') event: EventRead;
  public eventCopy: EventCopy;
  public userAccessLevel: number;
  public showModal = false;

  public constructor(
    public _eventsService: EventsV4Service,
    public _dialogService: DialogService,
    public _userService: UserService,
    public _navigationService: NavigationService,
    private _eventV4CustomRegFieldService: EventV4CustomRegFieldService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService
  ) {
    this.eventCopy = new EventCopy(0);

    this.userAccessLevel = 0;
  }

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;
    });
  }

  /**
   * handles copy button click
   */
  public async dulplicateClick(bypassValidation: boolean = false): Promise<void> {
    let eventCustomFieldsValid = true;

    if (bypassValidation === false) {
      eventCustomFieldsValid = await this._eventV4CustomRegFieldService.validateCustomFieldDropDownValues(this.event.EventId);
    }

    if (eventCustomFieldsValid === false) {
      this.invalidCustomFieldsConfirmation();
      return;
    }

    this.showModal = true;

    if (this.event) {
      this.eventCopy = new EventCopy(this.event.EventId);
      this.eventCopy.NewStartDate = this.event.StartDate;
    } else {
      this.eventCopy = new EventCopy(0);
    }
  }

  public cancelClick = (): void => {
    this.showModal = false;
  };

  public copyEvent = (): void => {
    this.showModal = false;
    this._dialogService.showWaitIndicator();
    this._eventsService.copyEvent(this.event.EventId, this.eventCopy).then(
      (newEventId) => {
        this._dialogService.closeWaitIndicator();
        this._navigationService.navigateToEventV4(newEventId);
      },
      (error: any) => {
        this._dialogService.closeWaitIndicator();
        this._dialogService.error(error);
      }
    );
  };

  private invalidCustomFieldsConfirmation() {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('events.settings.general.component.invalid-custom-field-warning', {
        action: this._translationService.getInstant('common.copy'),
      }),
      key: 'invalidCustomFieldsCDCopy',
      accept: () => this._confirmationService.close(),
    });
  }
}
